import { TThunkAction } from '../../types/redux';
import { sendTelemetryCounter } from '../../services/telemetry';
import {
  fetchIsSpecialistsCatalogAvailable,
  IIsSpecialistsCatalogAvailableRequest,
  IIsSpecialistsCatalogAvailableResponse200,
  IIsSpecialistsCatalogAvailableResponse400,
} from '../../repositories/demand/v1/is-specialists-catalog-available';

export const isSpecialistsAvailable = (
  params: IIsSpecialistsCatalogAvailableRequest,
): TThunkAction<Promise<boolean>> => {
  return async (dispatch, getState, context) => {
    const { httpApi, logger, config } = context;

    const timeout = config.get<number>('request-form-realtor-frontend.isSpecialistsCatalogAvailableTimeout') || 500;

    try {
      const res = await fetchIsSpecialistsCatalogAvailable<
        IIsSpecialistsCatalogAvailableResponse200,
        IIsSpecialistsCatalogAvailableResponse400
      >({
        httpApi,
        parameters: params,
        config: {
          ecnhancersConfig: {
            timeout,
          },
        },
      });

      if (res.statusCode !== 200) {
        throw res.response;
      }

      return res.response.available;
    } catch (error) {
      logger.error(error, {
        domain: 'isSpecialistsAvailable.ts',
        message: 'Unable to get is specialists catalog available',
      });

      if (error.type === 'TimeoutError') {
        sendTelemetryCounter({
          httpApi,
          key: `fetchIsSpecialistsCatalogAvailable.timeout`,
        });
      }

      return false;
    }
  };
};
